import { render, staticRenderFns } from "./classHistory.vue?vue&type=template&id=1deb30a2&scoped=true"
import script from "./classHistory.vue?vue&type=script&lang=js"
export * from "./classHistory.vue?vue&type=script&lang=js"
import style0 from "./classHistory.vue?vue&type=style&index=0&id=1deb30a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deb30a2",
  null
  
)

export default component.exports